import React, { useEffect, useRef, useState } from "react";
import {
  Table,
  Button,
  Spinner,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import { CoreContainer } from "../common/style";
import { isBrowser } from "react-device-detect";
import { Option } from "../product/style";
import { Notification } from "../common/style";
import { getCuttingGroupCutlist, getCuttingGroupCutlistCsv } from "./service";
import { useParams } from "react-router-dom";

const tableStyle = {
  width: "100%",
  fontSize: "12px",
};
const theadStyle = {
  textAlign: "left",
};
const tbodyStyle = {
  textAlign: "left",
};
const copyButtonStyle = {
  right: 0,
  top: "-43px",
};

const CuttingGroupCutlist = ({ cuttingGroup, projectId, showcolor }) => {
  const [cutlists, setCutlist] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [detailedCutlistView, setDetailedCutlistView] = useState(false);

  const [notification, setNotification] = useState({ type: "", message: "" });
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);

  const params = useParams();
  const orderId = params.orderId;

  const onDismissNotification = () => {
    setNotification({ type: "", message: "" });
    setIsNotificationVisible(false);
  };

  const handleDownload = async () => {
    getCuttingGroupCutlistCsv({
      cuttingGroupIdentifier: cuttingGroup.identifier,
      projectId: projectId,
      orderId,
      acceptHeader: "text/csv",
      downloadFormat: "optimalon",
      responseType: "blob",
    }).then((response) => {
      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const contentDisposition = response["content-disposition"];
      const fileName = contentDisposition
        .split("filename=")[1]
        .split(";")[0]
        .replace(/"/g, "");

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      link.setAttribute("target", "_blank");

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const loadCuttingGroupCutlist = () => {
    return getCuttingGroupCutlist({
      cuttingGroupIdentifier: cuttingGroup.identifier,
      projectId: projectId,
      orderId,
      acceptHeader: "application/json",
    })
      .then((cutlist) => {
        setCutlist(Object.values(cutlist).flat());
        setDetailedCutlistView(
          cutlist[0] && cutlist[0].hasOwnProperty("item_assembly_label")
        );
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    loadCuttingGroupCutlist();
  }, []);

  const [copied, setCopied] = useState(false);
  const [cuttingLengthVisible, setCuttingLengthVisible] = useState(false);

  const extractDimensions = (sideConfig) => {
    if (sideConfig.includes("Double Side")) {
      const sides = sideConfig.split(" ");
      if (sides.length === 3) {
        return [sides[2], sides[2]];
      }
    } else {
      const sides = sideConfig.split(" / ");
      if (sides.length === 2) {
        return sides;
      }
    }
    return ["", ""];
  };

  const tableRef = useRef(null);
  const [copiedContent, setCopiedContent] = useState("");

  const copyTableData = () => {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(tableRef.current);
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand("copy");
    selection.removeAllRanges();
    setCopiedContent(window.getSelection().toString());
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  if (notification.type) {
    return (
      <Notification
        color={notification.type === "error" ? "danger" : "success"}
        isOpen={isNotificationVisible}
        toggle={onDismissNotification}
      >
        {notification.message}
      </Notification>
    );
  }

  return isLoading ? (
    <CoreContainer height={isBrowser ? "70vh" : "50vh"}>
      <Spinner size="sm" style={{ margin: "auto" }}>
        Loading...
      </Spinner>
    </CoreContainer>
  ) : (
    <div className="overflow-hidden mt-3">
      {isBrowser && (
        <>
          <div
            className="mb-3 d-flex"
            style={{ justifyContent: "space-between" }}
          >
            <div
              className="btn-group me-3"
              style={{ border: "1px solid gainsboro" }}
            >
              <Option
                onClick={() => setCuttingLengthVisible(false)}
                className={`default-option1 ${
                  !cuttingLengthVisible && "selected-option1"
                }`}
              >
                Finish Length
              </Option>
              <Option
                onClick={() => setCuttingLengthVisible(true)}
                className={`default-option ${
                  cuttingLengthVisible && "selected-option1"
                }`}
              >
                Cutting Length
              </Option>
            </div>

            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
              <Button
                className="bg-light text-dark"
                style={copyButtonStyle}
                onClick={copyTableData}
              >
                {copied ? "Copied" : "Copy Cutlist"}
              </Button>
              <UncontrolledDropdown>
                <DropdownToggle
                  caret
                  className="justify-content-center align-items-center rounded-1 bg-success px-5 border-0 text-white fw-bold"
                  style={{ width: "150px", height: "32px" }}
                >
                  <span style={{ fontSize: "12px" }}>Download</span>
                </DropdownToggle>

                <DropdownMenu
                  style={{ backgroundColor: "#f7f2f2", fontSize: "12px" }}
                >
                  <DropdownItem
                    key={`optimalon`}
                    href="#"
                    onClick={handleDownload}
                  >
                    <span>Optimalon Format</span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </div>
        </>
      )}

      {cutlists.map((cutlist, index) => (
        <div className="p-2 position-relative cutlist-row d-flex" key={index}>
          <div>
            <span
              className="fw-bold text-white rounded-circle"
              style={{
                fontSize: "12px",
                backgroundColor: "gray",
                padding: "1px 6px 1px 6px",
              }}
            >
              {detailedCutlistView ? cutlist.item_assembly_label : index + 1}
            </span>
          </div>

          <div>
            <div className="d-flex flex-wrap align-content-center">
              <span className="mx-3">
                {!cuttingLengthVisible
                  ? cutlist.length_1
                  : cutlist.cutting_length_1}{" "}
                x{" "}
                {!cuttingLengthVisible
                  ? cutlist.length_2
                  : cutlist.cutting_length_2}
              </span>
              <span style={{ color: "gray" }}> {cutlist.name} </span>
              <span
                style={{ color: "gray", right: "10px" }}
                className={"position-absolute fw-bold"}
              >
                {cutlist.thickness + " mm"}
              </span>
            </div>

            <div
              className="d-flex justify-content-space-between"
              style={{ color: "gray", fontSize: "13px" }}
            >
              <div className="mt-2 mx-3">
                {showcolor && (
                  <span>
                    {cutlist.colors.length === 1 ? (
                      <div>Double side {cutlist.colors[0]}</div>
                    ) : (
                      <>
                        {!cutlist.colors[0] && `One side ${cutlist.colors[1]}`}
                        {!cutlist.colors[1] && `One side ${cutlist.colors[0]}`}
                        {cutlist.colors[0] &&
                          cutlist.colors[1] &&
                          `${cutlist.colors[0]} / ${cutlist.colors[1]}`}
                      </>
                    )}
                  </span>
                )}
                <span style={showcolor ? {} : { marginLeft: "12px" }}></span>
              </div>

              <div className="mt-2 mx-3">
                {cutlist.grooves && <span>Groove</span>}
                {((cutlist.grooves && cutlist.edges !== "No EG") ||
                  cutlist.has_minifix) &&
                  " | "}
                {cutlist.edges !== "No EG" && `${cutlist.edges} edge`}
                {cutlist.edges !== "No EG" && cutlist.has_minifix && " | "}
                {cutlist.has_minifix && <span>Minifix</span>}
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="opacity-0" style={{ height: "0px" }}>
        <Table innerRef={tableRef} style={tableStyle}>
          <thead style={theadStyle}>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              {detailedCutlistView && <th>Assembly Label</th>}
              <th>Material</th>
              <th>Thickness</th>
              <th>Finish Length 1</th>
              <th>Finish Length 2</th>
              <th>Cutting Length 1</th>
              <th>Cutting Length 2</th>
              <th>Side 1</th>
              <th>Side 2</th>
              <th>Remarks</th>
              <th>Edge</th>
            </tr>
          </thead>
          <tbody style={tbodyStyle}>
            {cutlists.map((cutlist, index) => {
              const [side1, side2] = extractDimensions(cutlist.side_config);
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{cutlist.name}</td>
                  {detailedCutlistView && (
                    <td>{cutlist.item_assembly_label}</td>
                  )}
                  <td>{cutlist.core_material}</td>
                  <td>{cutlist.thickness + " mm"}</td>
                  <td>{cutlist.length_1}</td>
                  <td>{cutlist.length_2}</td>
                  <td>{cutlist.cutting_length_1}</td>
                  <td>{cutlist.cutting_length_2}</td>
                  <td>{side1}</td>
                  <td>{side2}</td>
                  <td>
                    {cutlist.grooves}
                    {cutlist.has_minifix && cutlist.grooves ? " / " : ""}
                    {cutlist.has_minifix ? "Minifix" : ""}
                  </td>
                  <td>{cutlist.edges}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default CuttingGroupCutlist;
